import { render, staticRenderFns } from "./datatableListaPendenze.vue?vue&type=template&id=9dbef99e"
import script from "./datatableListaPendenze.vue?vue&type=script&lang=js"
export * from "./datatableListaPendenze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports